var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4998 7.16666C23.4006 7.16666 25.2234 7.92172 26.5674 9.26573C27.9114 10.6097 28.6665 12.4326 28.6665 14.3333C28.6665 16.234 27.9114 18.0569 26.5674 19.4009C25.2234 20.7449 23.4006 21.5 21.4998 21.5C19.5991 21.5 17.7762 20.7449 16.4322 19.4009C15.0882 18.0569 14.3332 16.234 14.3332 14.3333C14.3332 12.4326 15.0882 10.6097 16.4322 9.26573C17.7762 7.92172 19.5991 7.16666 21.4998 7.16666M21.4998 25.0833C29.419 25.0833 35.8332 28.2904 35.8332 32.25V35.8333H7.1665V32.25C7.1665 28.2904 13.5807 25.0833 21.4998 25.0833Z",
    fill: "#8D89A3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.6051521c57e27aedbce7333813df6b57.svg";
export { ForwardRef as ReactComponent };